const CreativeAgencyNewHero = () => {
  return (
    <>
      <div className="hero-36">
        <div className="sections__head">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-9">
                <h1 className="display-4 text-white text-center mb-0 fw-bold">
                  Micro Interactions 🔥 for your{" "}
                  <span className="hero-36__important">Webflow</span> Projects
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <img
                  src="assets/img/hero-36.png"
                  alt="Hero"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyNewHero;
